import { render } from "./App.vue?vue&type=template&id=2df964ee&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2df964ee&lang=scss&scoped=true"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.9.5__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df964ee"]])

export default __exports__